import "./QuickDetectTraceExplosives.module.css";
import Header from "@/reusable_sections/Header";
import TraceHero from "./sections/TraceHero";
import Capabilities from "./sections/Capabilities";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function QuickDetectTraceExplosivesPage() {
  return <div>
      <Header />
      <TraceHero />
      <Capabilities />
      <Inquiry />
      <Footer />
    </div>;
}